import { render, staticRenderFns } from "./authentication-success.vue?vue&type=template&id=2ec76e9c&scoped=true&"
var script = {}
import style0 from "./authentication-success.vue?vue&type=style&index=0&id=2ec76e9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec76e9c",
  null
  
)

export default component.exports